// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f24ab70","732":"b3436881","977":"b811f54a"}[chunkId] + ".chunk.js";
};